<td 
  class='lesson' 
  *ngFor='let index of [1,2,3,4,5,6,7,8,9,10]'
  [ngStyle]="!isCourseAvailable(index-1) ? {'background': '#eee'}: {}"
>
  <div class='song-numbers'>
    <p *ngIf='activitiesInLesson(index-1).length == 0'>
      <span class="icon cursor mt-add" *ngIf="isCourseAvailable(index-1)" (click)="openActivityManagePopover(index-1)"></span>
    </p>
    <div class="song-nums" *ngFor='let songNumber of activitiesInLesson(index-1); let isLast = last' (click)="openActivityManagePopover(index-1)">
      <button>{{songNumber}}</button>
      <button disabled *ngIf='!isLast'>,</button>
    </div>
  </div>
</td>